module.exports = __webpack_public_path__ + "static/pro_fct1-cd6db2d6768f03b7f42a7df1e9d5443c.jpg";